import React from 'react'
import { Typography } from '@s4l/ds'
import { License } from '@s4l/stayforlong/property/domain/License'
import type { UtilityClassNames } from '@s4l/utility-css'

interface PropertyLicenseProps {
  licenseJSON?: ReturnType<License['toJSON']>
  className?: UtilityClassNames
}

const PropertyLicense = ({ licenseJSON, className }: PropertyLicenseProps) => {
  if (!licenseJSON) {
    return null
  }

  const license = License.createOrNull(licenseJSON)

  if (!license) {
    return null
  }

  return (
    <Typography className={className} variant="body" size="l" bold as="p">
      {`${license.name()} · ${license.value()}`}
    </Typography>
  )
}
PropertyLicense.displayName = 'PropertyLicense'

export default PropertyLicense
